



















// 100% duplicated from ButtonSendEmail.vue

import Spinner from "vue-simple-spinner";
import sleep from "sleep-promise";
import { Election, Trustee, Vue } from "@/types.ts";

export default Vue.extend({
  components: {
    Spinner,
  },
  data() {
    return {
      status: "ready" as "ready" | "sending" | "sent",
    };
  },
  methods: {
    async sendEmail(trustee: Trustee) {
      this.status = "sending";
      await this.$store.dispatch("sendTrusteeEmail", {
        election: this.election,
        trustee,
      });
      await sleep(200);
      this.status = "sent";
    },
  },
  props: {
    election: {
      type: Object as () => Election,
      required: true,
    },
    trustee: {
      type: Object as () => Trustee,
      required: true,
    },
  },
});
